import { Box, Typography } from "@mui/material";
import { capitalize } from "lodash-es";

export const UtilityMessage = ({
	title,
	detail,
}: {
	title: string;
	detail?: string;
}) => (
	<Box sx={{ p: 4, textAlign: "center" }} role="status">
		<Typography variant="h6" fontWeight={700}>
			{title}
		</Typography>
		{detail && (
			<Typography color="text.secondary" sx={{ mt: 0.5 }}>
				{detail}
			</Typography>
		)}
	</Box>
);

export const WipState = ({ utility }: { utility: string }) => (
	<UtilityMessage
		title="Work in Progress"
		detail={`${capitalize(utility)} consumption is not available yet.`}
	/>
);
